import * as React from "react";

import { ActionSource } from "common/components/types";
import { GlideFunctionalRenderer } from "common/components/uis";
import EmbeddedAuthScreen from "../ui/smart/embedded-auth-screen/embedded-auth-screen";
import { useForceValueProducers } from "hooks/use-value-producers";
import { useForce } from "hooks/use-force";
import { useOnClickFromAction } from "hooks/use-on-click-from-action";

export const EmailAuthenticationMaterialRenderer: GlideFunctionalRenderer = p => {
    const { env, getValueProducers, ctx } = p;
    const [force] = useForce();
    const [[onSuccess, onAbort]] = useForceValueProducers(getValueProducers, force, ctx);
    const { onClick: success } = useOnClickFromAction(onSuccess, ActionSource.EmailAuthentication, ctx, env);
    const { onClick: abort } = useOnClickFromAction(onAbort, ActionSource.EmailAuthentication, ctx, env);

    return (
        <EmbeddedAuthScreen
            env={env}
            onSuccess={success !== undefined ? () => success(undefined) : undefined}
            onAbort={abort !== undefined ? () => abort(undefined) : undefined}
        />
    );
};
